import React from "react";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";
import arrow from "@src/assets/svg/arrow.svg";
import { OurNode } from "@src/cloud-connect/poc/our-node";

interface CaretHookTypes {
  handleCaretClick: (node: OurNode) => void;
}

type CaretProps = {
  child: OurNode;
  useHook: () => CaretHookTypes;
};

export const CaretOurNode = ({ child, useHook }: CaretProps) => {
  const { handleCaretClick } = useHook();
  const handleChildExpandedArrowRotation = (child: OurNode) => {
    return !child.collapsed;
  };

  return (
    <>
      {child.children.length > 0 && (
        <IconButton
          icon={arrow}
          fun={() => handleCaretClick(child)}
          rotate={handleChildExpandedArrowRotation(child)}
        />
      )}
    </>
  );
};
